/* =====================================================================
 * WorkspaceShell — compatibility facade.
 *
 * New route-first hosts mount GlobalRuntimeHost once at the app layout
 * level and render WorkspaceModeShell from each workspace route element.
 * Enterprise/on-prem hosts can keep using this facade unchanged.
 * ===================================================================== */

import React from 'react';
import { GlobalRuntimeHost } from './GlobalRuntimeHost';
import { WorkspaceModeShell } from './WorkspaceModeShell';

export interface WorkspaceShellProps {
  /**
   * Keep runtime effects mounted while suppressing route content.
   *
   * This remains for older hosts that temporarily hide WorkspaceShell while
   * rendering an external route. Route-first hosts should prefer mounting
   * GlobalRuntimeHost and route-specific layout elements directly.
   */
  readonly suspendContent?: boolean;
}

export const WorkspaceShell: React.FC<WorkspaceShellProps> = ({
  suspendContent = false,
}) => (
  <>
    <GlobalRuntimeHost />
    {!suspendContent && <WorkspaceModeShell />}
  </>
);
